<script lang="ts" setup>
// Properties
const props = defineProps({
    size: {
        type: String,
        default: "text-xl",
    },
    lineHeight: {
        type: String,
        default: "",
    },
});

// Data
</script>

<template>
    <h2 class="font-bold" :class="size + ' ' + lineHeight">
        <slot></slot>
    </h2>
</template>

<style scoped></style>
